import Vue from 'vue'

import store from '@/store/index'
import VueRouter from 'vue-router'

import AuthRoutes from '@/modules/router/auth.js'
import CPanelRoutes from '@/modules/router/cpanel'
import CPanelSession from '@/modules/router/session'
import CPanelVisit from '@/modules/router/visit'
import CPanelUser from '@/modules/router/user'
import Sales from '@/modules/router/sales'
import ServiceMenu from '@/modules/router/serviceMenu'
import ComplexExercises from '@/modules/router/complexExercises'
import LightVisit from '@/modules/router/lightVisit'
import HeatMarker from '@/modules/router/heatMarker'

import {Guest, middlewarePipeline} from './middleware'

Vue.use(VueRouter)

const routes = [
    {
        path: '/auth',
        name: 'auth',
        redirect: {name: 'auth.signin'},
        component: () => import('../../layouts/auth'),
        children: AuthRoutes,
        meta: {
            middleware: [Guest]
        }
    },

    {
        path: '/session',
        name: 'session',
        redirect: {name: 'session.create'},
        component: () => import('../../layouts/session'),
        meta: {
            middleware: [Guest],
            title: "Новая сессия"
        },
        children: CPanelSession
    },
    {
        path: '/visit',
        name: 'visit',
        redirect: {name: 'visit.list'},
        component: () => import('../../layouts/session'),
        meta: {
            middleware: [Guest],
        },
        children: CPanelVisit
    },
    {
        path: '/users',
        name: 'users',
        redirect: {name: 'users.list'},
        component: () => import('../../layouts/session'),
        meta: {
            middleware: [Guest],
        },
        children: CPanelUser
    },
    {
        path: '/serviceMenu',
        name: 'serviceMenu',
        redirect: {name: 'serviceMenu.statistic'},
        component: () => import('../../layouts/default'),
        meta: {
            middleware: [Guest],
        },
        children: ServiceMenu
    },
    {
        path: '/heatMarker',
        name: 'heatMarker',
        redirect: {name: 'heatMarker.list'},
        component: () => import('../../layouts/default'),
        meta: {
            middleware: [Guest],
        },
        children: HeatMarker
    },
    {
        path: '/complexExercises',
        name: 'complexExercises',
        redirect: {name: 'complexExercises.list'},
        component: () => import('../../layouts/default'),
        meta: {
            middleware: [Guest],
        },
        children: ComplexExercises
    },
    {
        path: '/lightVisit',
        name: 'lightVisit',
        redirect: {name: 'lightVisit.open'},
        component: () => import('../../layouts/default'),
        meta: {
            middleware: [Guest],
        },
        children: LightVisit
    },
    {
        path: '/',
        name: 'cpanel',
        redirect: {name: 'cpanel.dashboard'},
        component: () => import('../../layouts/default'),
        meta: {
            middleware: [Guest],
        },
        children: CPanelRoutes
    },
    {
        path: '/sales',
        name: 'sales',
        redirect: {name: 'sales.list'},
        component: () => import('../../layouts/session'),
        meta: {
            middleware: [Guest],
        },
        children: Sales
    },
    {
        path: '/404',
        name: '404',
        component: () => import('../../views/NotFound'),
        meta: {
            title: 'notFound.title'
        }
    },
    {
        path: '*',
        redirect: '/404'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes
})

middlewarePipeline(router, store);
export default router
